import Vue from 'vue';
import Router from 'vue-router';

import ViewerMaster from '@/components/report_preview/ViewerMaster';
import FullView2021 from '@/components/report_preview/gri2021_viewer/FullView2021';
import FullView2021Micro from '@/components/report_preview/gri2021_viewer/FullView2021Micro';
import Error from '@/components/Error.vue';

console.log('%c🟢 VIEWER/router.js LOADED', 'background: green; color: white; font-weight: bold; padding: 5px;')


const routes = [
  {
    path: '',
    component: ViewerMaster,
    children: [
      {
        path:
          process.env.VUE_APP_REPORT_CODE === undefined
            ? '/v'
            : process.env.VUE_APP_URL_NAME === undefined
              ? '/'
              : process.env.VUE_APP_URL_NAME,
        name: 'ReportView',
        component: FullView2021,
        props: true,
      },
      {
        path: '/micro',
        name: 'ReportViewMicro',
        component: FullView2021Micro,
        props: true,
      },
    ],
    props: true,
  },
  {
    path: '*',
    name: 'Error',
    component: Error,
  },

];


Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else return { x: 0, y: 0 };
  },
});

export default router;
